import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "CampaignEditorInputFieldWrapper" }
const _hoisted_2 = ["value", "disabled"]
const _hoisted_3 = { class: "WarningWidget WarningWidgetPrimary WarningWidgetBudgetLeft NoteWidget" }
const _hoisted_4 = { class: "WarningWidgetOuterContentWrapper WarningWidgetOneLine" }
const _hoisted_5 = { class: "WarningWidget WarningWidgetSecondary WarningWidgetBudgetTotal NoteWidget" }
const _hoisted_6 = { class: "WarningWidgetOuterContentWrapper WarningWidgetOneLine" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("input", {
        class: _normalizeClass([
				'CampaignEditorInputField',
				{ 'BudgetCustomInputField': _ctx.isBudgetTypeCustom },
				{ 'ContentInvalid': _ctx.isFieldValidatedAndMissing || _ctx.isFieldValidatedAndInvalid }
			]),
        type: "number",
        value: _ctx.storedBudget,
        disabled: _ctx.isFieldDisabled,
        onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setBudgetBasedOnEvent && _ctx.setBudgetBasedOnEvent(...args)))
      }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_2),
      (_ctx.isBudgetTypeCustom)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([
				'ValidationMessage',
				{ 'ContentInvalid': _ctx.isFieldValidatedAndMissing || _ctx.isFieldValidatedAndInvalid }
			])
          }, _toDisplayString(_ctx.validationMessage), 3 /* TEXT, CLASS */))
        : _createCommentVNode("v-if", true)
    ]),
    (_ctx.isBudgetTypeCustom)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_3, [
            _cache[1] || (_cache[1] = _createElementVNode("i", { class: "lnr-bag-coins WarningWidgetIcon" }, null, -1 /* CACHED */)),
            _createElementVNode("span", _hoisted_4, " Budget left:    " + _toDisplayString(_ctx.budgetLeft), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("i", { class: "lnr-bag-coins WarningWidgetIcon" }, null, -1 /* CACHED */)),
            _createElementVNode("span", _hoisted_6, " Total campaign budget:    " + _toDisplayString(_ctx.budgetTotal), 1 /* TEXT */)
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}